import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

const ProtectedRiderRoute = ({ children }) => {
  const { admin, checking } = useAuth();
  if (checking) return <div className="min-h-[50vh] flex items-center justify-center text-navy/50">Loading…</div>;
  if (!admin) return <Navigate to="/rider/login" replace />;
  if (admin.role !== "rider") {
    if (admin.role === "restaurant") return <Navigate to="/restaurant-admin" replace />;
    return <Navigate to="/admin" replace />;
  }
  return children;
};

export default ProtectedRiderRoute;
